import { MapPin } from "lucide-react";
import { CONTACT } from "../data/site";
import { Reveal } from "./Reveal";

export const Location = () => (
  <div className="grid grid-cols-1 lg:grid-cols-5 gap-10 lg:gap-16 items-center">
    <div className="lg:col-span-2">
      <Reveal>
        <p className="font-hand text-2xl sm:text-3xl text-[#8A9B87] -rotate-1">löydät meidät täältä</p>
      </Reveal>
      <Reveal delay={0.08}>
        <h2 className="mt-3 text-3xl sm:text-4xl font-light tracking-tight">Sijainti</h2>
      </Reveal>
      <Reveal delay={0.14}>
        <address className="mt-6 flex gap-3 not-italic text-base text-[#2E2E2C]/80">
          <MapPin size={20} strokeWidth={1.6} className="mt-0.5 shrink-0 text-[#A9805B]" />
          <span>{CONTACT.address}</span>
        </address>
      </Reveal>
      <Reveal delay={0.2}>
        <p className="mt-4 text-base md:text-lg text-[#2E2E2C]/70 leading-relaxed">
          Kävelymatkan päässä Porvoon Vanhasta kaupungista.
        </p>
      </Reveal>
    </div>

    <Reveal delay={0.12} className="lg:col-span-3">
      <div className="overflow-hidden rounded-3xl border border-[#8A9B87]/20 shadow-[0_8px_30px_rgb(0,0,0,0.04)]">
        <iframe
          title="Hengähdys — Sauna ja Tila kartalla, Itäinen Pitkäkatu 25 B, Porvoo"
          data-testid="location-map"
          src="https://maps.google.com/maps?q=It%C3%A4inen%20Pitk%C3%A4katu%2025%20B%2C%2006100%20Porvoo&t=&z=15&ie=UTF8&iwloc=&output=embed"
          className="h-[340px] sm:h-[420px] w-full border-0"
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </div>
    </Reveal>
  </div>
);
